import { Component,ChangeDetectorRef,OnInit,ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CareerService } from '../../../services/career.service';
import { ToastrService } from 'ngx-toastr';
import { Captcha } from '../../../services/captcha.model';
import { environment } from '../../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup, Validators,FormsModule,ReactiveFormsModule } from '@angular/forms';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-apply-position',
  imports: [CommonModule,ReactiveFormsModule,FormsModule,RecaptchaFormsModule,RecaptchaModule],
  standalone: true,
  templateUrl: './apply-position.component.html',
  styleUrl: './apply-position.component.scss'
})
export class ApplyPositionComponent implements OnInit {
 @ViewChild('resumeFileUpload') resumeFileUpload: any;
  choosenResumeFileStream: string = '';
  id: any;
  jobdata: any = [];
  formModel: Captcha = {};
  captchaToken: any;
  captchaSiteKey = environment.googleRecaptchaSiteKey;

  public jobDetails: any;

   constructor(
    private router: Router,
    private careerservice: CareerService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef
  ) {}

  bool = false;
  bool1 = false;
  bool2 = true;
  imageError: any;
  isImageSaved: any;
  cardImageBase64: any;

  nav(url: any) {
    this.router.navigateByUrl(url)
  }

  applyForm = new FormGroup({
    FirstName: new FormControl('', [
      Validators.required,
      Validators.pattern('[a-zA-Z]*'),
    ]),
    LastName: new FormControl('', [
      Validators.required,
      Validators.pattern('[a-zA-Z]*'),
    ]),
    email: new FormControl('', [Validators.required, Validators.email]),
    contact: new FormControl('', [
      Validators.required,
      Validators.maxLength(10),
      Validators.pattern('[0-9]*'),
    ]),
    experience: new FormControl('', [
      Validators.required,
      Validators.pattern('[0-9]*'),
    ]),
    notice: new FormControl('', [
      Validators.required,
      Validators.pattern('[0-9]*'),
    ]),
    EmployeeStatus: new FormControl('', [Validators.required]),
    filename: new FormControl('', [Validators.required]),
    captcha: new FormControl('', [Validators.required]),
  });

  ngOnInit(): void {
    this.route.paramMap.subscribe({
      next: (params) => {
        this.id = params.get('id');
        if (this.id) {
          this.careerservice.getJob().subscribe({
            next: (result) => {
              this.jobdata = result;
              this.updateResponse();
            },
            error: () => {
              console.log('Invalid Request');
            },
          });
        }
      },
    });
  }

  updateResponse() {
    if (this.jobdata && this.jobdata.length) {
      this.jobdata.forEach((data: any) => {
        if (data.JobId == this.id) {
          this.jobDetails = data;
        }
        if (data.TechnicalExperties) {
          data.updatedTechnicalExperties = data.TechnicalExperties.split('::');
        }
      });
    }
  }
  
  verifyCaptcha(captchaResponse: any) {
    this.captchaToken = captchaResponse;
    this.applyForm.get('captcha')?.setValue(captchaResponse);
    this.applyForm.get('captcha')?.updateValueAndValidity();
  }

  sendEmail(id: any) {
  if (!this.jobdata || !this.jobdata.length) {
    this.toastr.error('Job data not available.');
    return;
  }

  // Find the job by its JobId
  const job = this.jobdata.find((job: any) => job.JobId == id);
  
  if (!job) {
    this.toastr.error('Job not found.');
    return;
  }

  let payload: any = this.applyForm.value;
  payload.JobName = job.JobTitle || 'Unknown Job Title';  // Use the found job's JobTitle

  if (this.choosenResumeFileStream) {
    payload.Base64file = this.choosenResumeFileStream.split(',').pop();
  }
 
  const applyObservable = job.Location.toLowerCase().includes('india')
      ? this.careerservice.applyIndiaJob(payload)
      : this.careerservice.applyUSAJob(payload);

    applyObservable.subscribe({
      next: (result) => {
        this.applyForm.reset();
        this.toastr.success('Applied Successfully');
        this.router.navigate(['/careers/open-positions']);
      },
      error: (error: any) => {
        this.toastr.error(
          'Error raised while processing your Application. Please Re-Apply or Contact the support team'
        );
      },
    });
  }


  get FirstName() {
    return this.applyForm.get('FirstName');
  }

  get LastName() {
    return this.applyForm.get('LastName');
  }

  get email() {
    return this.applyForm.get('email');
  }

  get contact() {
    return this.applyForm.get('contact');
  }

  get experience() {
    return this.applyForm.get('experience');
  }

  get notice() {
    return this.applyForm.get('notice');
  }

  get filename() {
    return this.applyForm.get('resume');
  }

  get EmployeeStatus() {
    return this.applyForm.get('EmployeeStatus');
  }

  showToast() {
    if (this.applyForm.valid) {
      this.toastr.success('Applied Successfully', '');
      this.bool = true;
      this.applyForm.reset();
      this.bool1 = false;
    } else {
      this.bool1 = true;
      this.toastr.error('Please Enter The Required Fields');
    }
  }

  public selectResume() {
    this.resumeFileUpload?.nativeElement?.click();
  }

  fileName = '';
  public resumeGotSelected(e: any) {
    if (e?.target?.files?.length) {
      let file = e.target.files[0];
      if (file) {
        this.applyForm.get('filename')?.setValue(file.name);
        let fileReader = new FileReader();

        fileReader.onload = (e: any) => {
          this.choosenResumeFileStream = e?.target?.result;
        };
        fileReader.onerror = (error) => {
          console.log('Error: ', error);
        };

        fileReader.readAsDataURL(file);
        this.bool2 = false;
      }
    }
  }
}
